import { authSettingsUsersItemComponent } from './components/authsettings.usersItem.component';
import { authSettingsServerComponent } from './components/authsettings.server.component';
import { AuthUserService } from './services/authusers.service';
import { AuthSettingsApi } from './services/authsettings.factory';
import { authServiceRun } from './authsettings.run';
import { authSettingsUsersComponent } from './components/authsettings.users.component';
import { authSettingsComponent } from './components/authsettings.component';
import { resetPasswordComponent } from './components/resetPassword.component';
import {
    authSettingsServerState,
    authSettingsState,
    authSettingsUsersItemState,
    authSettingsUsersState
} from './authsettings.states';
import { AuthSettingsService } from './services/authsettings.service';

import { loadNg1Module, ngmodule } from "../bootstrap/ngmodule";

const authSettingsAppModule: aboTheme.INgModule = {
  components: { authSettingsComponent, authSettingsUsersComponent, authSettingsServerComponent, authSettingsUsersItemComponent, resetPasswordComponent },
  states: [ authSettingsState, authSettingsUsersState, authSettingsServerState, authSettingsUsersItemState ],
  services: { AuthSettingsService, AuthUserService },
  runBlocks: [ authServiceRun ],
  factories: { AuthSettingsApi }
};

loadNg1Module(ngmodule, authSettingsAppModule);


// WEBPACK FOOTER //
// ./src/app/authsettings/index.ts